const Footer = () => {
  return (
    <footer className="footer mt-auto bg-dark">
      <div className="container">
        <p className="text-light">App desenvolvido por <a href="https://www.linkedin.com/in/fernando-fgonsales/"
          target="_blank" rel="noreferrer">Fernando Gonsales</a></p>
      </div>
    </footer>
  );
}

export default Footer;
